import { render, staticRenderFns } from "./editProjects.vue?vue&type=template&id=5aa8e1fe&"
import script from "./editProjects.vue?vue&type=script&lang=js&"
export * from "./editProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports